module.exports = __webpack_public_path__ + "static/media/lotusworks.d0a10240.png";